<div class="progressStep">
  <div class="step" [class.active]="step === 1" *ngIf="maxSteps >= 1">
    <span class="icon-edit" *ngIf="step === 1"></span>
    <span class="icon-checkmark" *ngIf="step > 1"></span>
    <span class="progressText">{{stepNames[0]}}</span>
    <span class="icon-primary"></span>
  </div>
  <div class="step" [class.active]="step === 2" *ngIf="maxSteps >= 2">
    <span class="icon-edit" *ngIf="step === 2"></span>
    <span class="icon-checkmark" *ngIf="step > 2"></span>
    <span class="emptyIcon" *ngIf="step < 2">&nbsp;</span>
    <span class="progressText">{{stepNames[1]}}</span>
    <span class="icon-secondary"></span>
  </div>
  <div class="step" [class.active]="step === 3" *ngIf="maxSteps >= 3">
    <span class="icon-edit" *ngIf="step === 3"></span>
    <span class="icon-checkmark" *ngIf="step > 3"></span>
    <span class="emptyIcon" *ngIf="step < 3">&nbsp;</span>
    <span class="progressText">{{stepNames[2]}}</span>
    <span class="icon-tertiary"></span>
  </div>
</div>
